export default function Hooks() {
  return {
    preDraft: [],
    postDraft: [],
    preSample: [],
    postSample: [],
    preRender: [],
    postRender: [],
    insertText: [],
  }
}
